import Constants from '../../constants/AuthConstant';
class TenantAction {
   
static  fetchUserRequest = () => ({
    type: Constants.FETCH_USER_REQUEST,
});

static fetchUserSuccess = (user) => ({
    type: Constants.FETCH_USER_SUCCESS,
    payload: user,
});

static fetchUserFailure = (error) => ({
    type: Constants.FETCH_USER_FAILURE,
    payload: error,
});

static TenantRequest = (credentials) => ({
    type: Constants.TENANT_REQUEST,
    payload: credentials,
});

static TenantSuccess = (user) => ({
    type: Constants.TENANT_SUCCESS,
    payload: user,
});

static TenantFailure = (error) => ({
    type: Constants.TENANT_FAILURE,
    payload: error,
});

static GetAllCitiesFromStateRequest = (stateId) => ({
    type: Constants.GET_ALLCITIESFROMSTATE_REQUEST,
    payload: stateId,
});

static GetAllCitiesFromStateSuccess = (stateId) => ({
    type: Constants.GET_ALLCITIESFROMSTATE_SUCCESS,
    payload: stateId,
});

static GetAllCitiesFromStateFailure = (stateId) => ({
    type: Constants.GET_ALLCITIESFROMSTATE_FAILURE,
    payload: stateId,
});


static CreateTenantRequest = (credentials) => ({
    type: Constants.CREATE_TENANT_REQUEST,
    payload: credentials,
});

static CreateTenantSuccess = (user) => ({
    type: Constants.CREATE_TENANT_SUCCESS,
    payload: user,
});

static CreateTenantFailure = (error) => ({
    type: Constants.CREATE_TENANT_FAILURE,
    payload: error,
});

static UpdatePaymentTenantRequest = (credentials) => ({
    type: Constants.UPDATE_TENANT_PAYEMENT_REQUEST,
    payload: credentials,
});

static UpdatePaymentTenantSuccess = (user) => ({
    type: Constants.UPDATE_TENANT_PAYEMENT_SUCCESS,
    payload: user,
});

static UpdatePaymentTenantFailure = (error) => ({
    type: Constants.UPDATE_TENANT_PAYEMENT_FAILURE,
    payload: error,
});

static SetSkippedPaymentRequest = (credentials) => ({
    type: Constants.SET_SKIPPED_PAYMENT_REQUEST,
    payload: credentials,
});

static SetSkippedPaymentSuccess = (user) => ({
    type: Constants.SET_SKIPPED_PAYMENT_SUCCESS,
    payload: user,
});

static SetSkippedPaymentFailure = (error) => ({
    type: Constants.SET_SKIPPED_PAYMENT_FAILURE,
    payload: error,
});
}

export default TenantAction;